import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ComponentNameTranslationPipe, LevelNameTranslationPipe } from '@twaice-fe/frontend/shared/services';
import { LimitingCellDetection, StorageLevelV2, WeakCellPosition } from '@twaice-fe/shared/models';
import { NzCardComponent } from 'ng-zorro-antd/card';

@Component({
  selector: 'twaice-fe-limiting-cell-recommendation',
  templateUrl: './limiting-cell-recommendation.component.html',
  imports: [CommonModule, NzCardComponent, ComponentNameTranslationPipe, LevelNameTranslationPipe],
  providers: [LevelNameTranslationPipe],
  styleUrl: './limiting-cell-recommendation.component.scss',
})
export class LimitingCellRecommendationComponent {
  @Input() componentBk: string | undefined;
  @Input() enclosureBk: string | null;
  @Input() weakCellPosition: WeakCellPosition | null;
  @Input() limitingCellDetection: LimitingCellDetection | null;
  @Input() hasSiblingEffect = false;

  @Input() quickFixBufferPercent: number;

  protected readonly storageLevelV2 = StorageLevelV2;

  constructor(private levelIdentifierToLevelName: LevelNameTranslationPipe) {}

  getCellPosition(): string | null {
    const { cellPosition, modulePosition } = this.weakCellPosition ?? {};
    const cellPositionString = cellPosition
      ? `${this.levelIdentifierToLevelName.transform(StorageLevelV2.Cell)} ${cellPosition}`
      : null;
    const modulePositionString = modulePosition
      ? `${this.levelIdentifierToLevelName.transform(StorageLevelV2.StringModule)} ${modulePosition}`
      : null;

    if (cellPosition && modulePosition) {
      return `(${modulePositionString}, ${cellPositionString})`;
    }

    if (modulePosition) {
      return `(${modulePositionString})`;
    }

    if (cellPosition) {
      return `(${cellPositionString})`;
    }

    return null;
  }
}
